import React from 'react';
import './index.scss';

function PromoSlot({
  iconImg = '',
  heading = '',
  linkText = '',
  linkUrl = ''
}) {
  return (
    <div className="mobileAppsBanner">
      <div className="iconWrap">
        <img src={iconImg} alt="" />
      </div>
      <p>{heading}</p>
      <a
        href={linkUrl}
        target="_blank"
        rel="noreferrer"
        className="dialogComponent"
      >
        {linkText}
      </a>
    </div>
  );
}

export default PromoSlot;
